import script from "./ModalItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalItem.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__